import React from 'react';
import { useStyletron } from 'baseui';

import { DataList, Loader } from 'commons-ui';
import Accordian from 'commons-ui/src/components/keyValueView/Accordian';
import { LIST_ENTITY_NAMES } from 'constant';
import { columnConfigs } from './listConfig';
import useKycDocsHistory from './useKycDocsHistory';

const KycDocsHistory: React.FC<{}> = () => {
	const { kycDocsIsCollapsed, setKycDocsIsCollapsed, showLoader, handleDatalistFetchData, dataFetchComplete } = useKycDocsHistory();
	const [css] = useStyletron();

	const KycDocsLabel = (
		<div className={css({ display: 'flex', justifyContent: 'space-between', minWidth: '500px' })}>
			<div className={css({ fontWeight: 'bold', padding: '12px 0px' })}>Kyc Docs History</div>
		</div>
	);

	return (
		<>
			{showLoader && <Loader />}
			<Accordian
				label={KycDocsLabel}
				panelKey='unnamedPanel'
				isCollapsed={kycDocsIsCollapsed}
				setIsCollapsed={setKycDocsIsCollapsed}>
				{dataFetchComplete && (
					<DataList
						fetchData={handleDatalistFetchData}
						columnConfigs={columnConfigs}
						hideActions
						entity={LIST_ENTITY_NAMES.KYC_DETAILS}
						filterable={false}
						searchable={false}
						rowHeight={180}
						disablePagination
						showFooterMessage={false}
					/>
				)}
			</Accordian>
		</>
	);
};

export default KycDocsHistory;
